import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export interface SlideTemplateDto {
  id: string;
  name: string;
  slug: string;
  context: string;
  type: string;
  templateJson: Record<string, unknown>;
  selectionCriteria?: {
    playerTypes?: string[];
    orientation?: 'landscape' | 'portrait';
    mediaCapacity?: number;
    roomCamCapacity?: number;
    remoteSpeakerCapacity?: number;
  };
  updatedAt: string;
}

export const GET_SLIDE_TEMPLATES_QUERY_KEY = 'get-slide-templates';

export const useGetSlideTemplatesQuery = (params?: { type?: string; context?: string }) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_SLIDE_TEMPLATES_QUERY_KEY, params],
    queryFn: async () => {
      const token = await getToken();
      const search = new URLSearchParams();
      if (params?.type) search.set('type', params.type);
      if (params?.context) search.set('context', params.context);
      const url = `${import.meta.env.VITE_API_URL}/slide-templates${search.toString() ? `?${search}` : ''}`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? undefined }) as Promise<SlideTemplateDto[]>;
    },
  });
};
